import React from 'react';

const Footer = () => (
    <footer className="footer">
        <div className="container">
            <div className="row">
                <div className="col-xl-3 col-md-3 col-sm-6">
                    <div className="company-name">Oriah Behavioral Health, Inc.</div>
                    <div className="company__address">1215 Route 70, Suite 2001, Lakewood, NJ 08701</div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                    <div className="footer__email"><span>Email: </span><a href="mailto:Info@ManageAddiction.com">Info@ManageAddiction.com</a>
                    </div>
                    <div className="footer__phone"><span>Phone: </span><a href="tel:888-218-8228">888-218-8228</a>
                    </div>
                    <div className="footer__fax"><span>Fax: </span><span>732-942-5058</span></div>
                </div>
                <div className="col-xl-2 col-md-3 col-sm-6"><span className="footer__title">About</span><a
                    className="footer__link" href="https://manageaddiction.com/about-this-program/">About the program</a>
                    <a className="footer__link" href="https://manageaddiction.com/meet-the-doctor/">Meet the doctor</a>
                    <a className="footer__link" href="https://manageaddiction.com/blog/">News</a></div>
                <div className="col-xl-1 col-md-2 col-sm-6"><span className="footer__title">Help</span><a
                    className="footer__link" href="https://manageaddiction.com/terms/">Terms</a>
                    <a className="footer__link" href="https://manageaddiction.com/faq/">Faq</a>
                    <a className="footer__link" href="https://manageaddiction.com/privacy/">Privacy</a>
                    <a className="footer__link" href="https://manageaddiction.com/contact-us/">Contact us</a>
                    <a className="footer__link" href="https://manageaddiction.com/careers/">Careers</a></div>
                <div className="col-xl-3 col-lg-12">
                    <div className="nav__social footer__social">
                        <a href="https://www.facebook.com/ManageAddiction"><i className="fab fa-facebook-square"></i></a>
                        <a href="https://www.instagram.com/manageaddiction/"><i className="fab fa-instagram"></i></a>
                        <a href="https://www.linkedin.com/company/manageaddiction/"><i className="fab fa-pinterest-square"></i></a>
                        <a href="https://twitter.com/ma_lifeline"><i className="fab fa-twitter-square"></i></a>
                        <a href="https://www.youtube.com/channel/UC01qAs0Nw8dXBGZgzClSSJg"><i className="fab fa-youtube"></i></a></div>
                </div>
                <div className="col-12">
                    <div className="footer__separator"></div>
                    <div className="footer__privacy">Sampletext area The information on this website is for
                        informational purposes only; it is deemed accurate but not guaranteed. It does not
                        constitute professional advice. Testimonials are not a guarantee, warranty or prediction of
                        what your experience with us will be. Lorem ipsum dolor
                    </div>
                    <div className="footer__copyright">Copyright 2018. All Rights Reserved</div>
                </div>
            </div>
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/component/Footer.js